import { useCallback } from 'react';
import { css } from '@emotion/react';
import { ScheduleAvailabilityTypes as Types } from '@frontend/api-schedule-availability';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

interface AddBreakButtonProps {
  day: Types.Weekday;
  onClick: (day: Types.Weekday) => void;
  disabled?: boolean;
}

export const AddBreakButton = ({ day, disabled = false, onClick }: AddBreakButtonProps) => {
  const { t } = useTranslation('schedule');

  const handleClick = useCallback(() => {
    onClick(day);
  }, [day, onClick]);

  return (
    <Button
      hoverLabel={t('Add Break')}
      iconName='plus'
      variant='secondary'
      size='small'
      onClick={handleClick}
      css={buttonStyle}
      disabled={disabled}
    />
  );
};

const buttonStyle = css({
  border: `1px solid ${theme.colors.neutral30}`,
  borderRadius: theme.borderRadius.full,
  height: theme.spacing(2.5),
  width: theme.spacing(2.5),
  padding: 0,
});
